module.exports = __webpack_public_path__ + "img/1527197085.f8b7af03.jpg";